import API from './api';

export const availabilityAPI = {
  get: () => API.get('/availability'),
};